import { render, staticRenderFns } from "./OneX.vue?vue&type=template&id=0de31974"
import script from "./OneX.vue?vue&type=script&lang=js"
export * from "./OneX.vue?vue&type=script&lang=js"
import style0 from "./OneX.vue?vue&type=style&index=0&id=0de31974&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports